import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  ComponentRef
} from '@angular/core';
import Swal from 'sweetalert2';
import { SweetSelectComponent } from './sweet-select.component';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {
  constructor(
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  openSelectModal(
    title: string,
    text: string,
    options: { label: string; value: any }[],
    preSelected: any[] = [],
    placeholder = '-- Select Options --'
  ) {
    let selectedValues: any[] = [...preSelected];
    let componentRef: ComponentRef<SweetSelectComponent> | null = null;

    return Swal.fire({
      title,
      html: `<p style="margin-bottom:30px;">${text}</p><div id="ng-select-container" style="margin-right: 50px;
    margin-bottom: 30px;
    margin-left: 50px;"></div>`,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#5163B7',
      cancelButtonColor: '#d33',

      // 🔸 Compatible with older SweetAlert2
      onOpen: () => {
        const container = document.getElementById('ng-select-container');
        if (container) {
          const factory = this.resolver.resolveComponentFactory(SweetSelectComponent);
          componentRef = factory.create(this.injector);
          this.appRef.attachView(componentRef.hostView);
          container.appendChild((componentRef.hostView as any).rootNodes[0]);

          componentRef.instance.options = options;
          componentRef.instance.selected = preSelected;
          componentRef.instance.placeholder = placeholder;
          componentRef.instance.selectionChange.subscribe(values => {
            selectedValues = values;
          });
        }
      },

      preConfirm: () => selectedValues,

      onClose: () => {
        if (componentRef) {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        }
      }
    });
  }
}
